<div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>

<div style="padding: 10px;">
    <div style="padding: 10px; margin-bottom: 10px; text-align: left;">
        <span style="font-size: x-large; font-weight: bold;">{{dataTableDescription}}</span>
        <span *ngIf="filterString.length > 0">&nbsp; [filter active]</span>

        <span *ngIf="showControlButtons" style="float:right;">
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="toggleShowFilter()">
                <span *ngIf="showFilter">Hide</span>
                <span *ngIf="!showFilter">Show</span>
                Filter
            </button>
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="addDocument()" [disabled]="!canEdit">New Row</button>
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="editTableStructure()" [disabled]="!canEdit || !canAlter">Edit {{dataTableName}} Structure</button>
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="exportTable()" [disabled]="!canExport">Export Table</button>
            <button mat-raised-button color="warn" style="margin-left: 10px;" (click)="deleteTable()" [disabled]="!canEdit || !canDelete">Delete {{dataTableName}}</button>
        </span>
    </div>

    <div *ngIf="showFilter" style="width: 100%;">
        <mat-form-field *ngIf="dataTable">
            <mat-label>Select Filter Column</mat-label>
            <mat-select [(value)]="selectedFilterColumn" name="filterColumn" (selectionChange)="filterColumnChanged()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let column of filterColumns" [value]="column">
                    {{column}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="dataTable && selectedFilterColumn" style="margin-left: 10px;">
            <mat-label>Filter</mat-label>
            <input matInput name="filterString" [(ngModel)]="filterString" (input)="onFilterChange()">
            <button mat-button matSuffix (click)="filterString=''; sortData(currentSort);"><mat-icon>close</mat-icon></button>
        </mat-form-field>

        <button *ngIf="dataTable && selectedFilterColumn" mat-raised-button color="primary" (click)="clearFilter()" style="margin-left: 10px;">
            Clear Filter
        </button>
    </div>

    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8" style="width: 100%;">
        <div [class]="getTableClass()">
            <table mat-table
                    [dataSource]="sortedData"  
                    matSort
                    [matSortActive]="currentSort.active"
                    [matSortDirection]="currentSort.direction"
                    (matSortChange)="sortData($event)"
                    cdkDropList
                    cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="drop($event)">

                <ng-container *ngFor="let column of displayedColumns;" matColumnDef="{{column}}">
                    <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> {{column}} </th>
                    <td mat-cell *matCellDef="let row"> {{row[column]}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; let i=index; columns: displayedColumns;" class="table-row" (click)="rowClicked(i)"></tr>
            </table>
        </div>
    </mat-card>
</div>